import React from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';

const CancelJobModal = ({ show, setShow, jobId, cancelJobHandler, fetchingData }) => (
  <Modal
    show={show}
    onHide={() => setShow(false)}
  >
    <Modal.Header closeButton>
      Cancel running job?
    </Modal.Header>
    <Modal.Body>
      Are you sure you want to cancel job {jobId}?
    </Modal.Body>
    <Modal.Footer>
      <Button
        onClick={() => setShow(false)}
        variant='outline-secondary'
      >
        Close
      </Button>
      <Button
        variant='danger'
        onClick={() => cancelJobHandler()}
        disabled={fetchingData}
      >
        {fetchingData ? (
          <Spinner className='mr-1' animation='border' variant='light' size='sm' />
        ) : null}
        Cancel Job
      </Button>
    </Modal.Footer>
  </Modal>
);

export default CancelJobModal;
